module.exports = __webpack_public_path__ + "img/cover7.0f857c20.jpeg";